/**
 * Тексты ошибок ловли (этап 1).
 *
 * Вынесены отдельным модулем: eslint-plugin-react-refresh запрещает
 * экспортировать из файла с компонентом что-либо, кроме компонентов
 * (иначе ломается Fast Refresh в дев-режиме).
 */
export const CATCH_ERROR_LABELS: Record<string, string> = {
  catcher_is_violator: "Нельзя поймать себя",
  violator_has_checkin: "Участник уже отметился",
  penalty_already_processed: "Штраф уже начислен",
  deposit_exhausted: "У нарушителя не хватает FP",
  membership_not_active:
    "Ловить может только активный участник клуба — пополни FP или вступи заново",
  habit_not_found: "Клуб не найден",
  rate_limited: "Слишком много попыток — подожди",
  // Этап 1: замороженная жертва и жертва вне игры (A45).
  victim_frozen:
    "Участника сейчас нет в игре — его участие на паузе, поймать его нельзя",
  violator_not_in_game:
    "Участник вступил после закрытия окна — в тот день отметиться не мог, штрафа не будет",
};
